// extracted by mini-css-extract-plugin
export default {"setting-audio":"SettingAudioButton_setting-audio__NOX8Z","setting-audio-icon":"SettingAudioButton_setting-audio-icon__GCGBR"};